import getCompany from "./getCompany";

const maxCost = type => {
  if (type === 1) return undefined;

  try {
    const companyType = getCompany().selected.componyTypeId;
    if (companyType === 10) {
      return { value: 50000000, message: "حداکثر ارزش کالا 50 میلیون ریال" };
    } else {
      return { value: 500000000, message: "حداکثر ارزش کالا 500 میلیون ریال" };
    }
  } catch (error) {
    return undefined;
  }
};

export default maxCost;
